import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { TextInputWithTokens } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTablePassthroughPropsRow = makeShortcode("PropsTablePassthroughPropsRow");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A `}<inlineCode parentName="p">{`TextInputWithTokens`}</inlineCode>{` component supports all of the features of a `}<a parentName="p" {...{
        "href": "/TextInput"
      }}>{`TextInput`}</a>{` component, but it can render a list of `}<a parentName="p" {...{
        "href": "/Token"
      }}>{`Tokens`}</a>{` next to the area a user types in.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const BasicExample = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2}
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <FormControl>
      <FormControl.Label>Basic example tokens</FormControl.Label>
      <TextInputWithTokens tokens={tokens} onTokenRemove={onTokenRemove} />
    </FormControl>
  )
}

render(BasicExample)
`}</code></pre>
    <h3>{`Using a different token component`}</h3>
    <p>{`By default, the `}<inlineCode parentName="p">{`Token`}</inlineCode>{` component is used to render the tokens in the input. If this component does not make sense for the kinds of tokens you're rendering, you can pass a component to the `}<inlineCode parentName="p">{`tokenComponent`}</inlineCode>{` prop`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const UsingIssueLabelTokens = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'enhancement', id: 1, fillColor: '#a2eeef'},
    {text: 'bug', id: 2, fillColor: '#d73a4a'},
    {text: 'good first issue', id: 3, fillColor: '#0cf478'}
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <FormControl>
      <FormControl.Label>Issue labels</FormControl.Label>
      <TextInputWithTokens tokenComponent={IssueLabelToken} tokens={tokens} onTokenRemove={onTokenRemove} />
    </FormControl>
  )
}

render(<UsingIssueLabelTokens />)
`}</code></pre>
    <h3>{`Dealing with long lists of tokens`}</h3>
    <p>{`By default, all tokens will be visible when the component is rendered.`}</p>
    <p>{`If the component is being used in an area where it's height needs to be constrained, there are options to limit the height of the input.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const VisibleTokenCountExample = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2},
    {text: 'three', id: 3}
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <Box maxWidth="500px">
      <FormControl>
        <FormControl.Label>Tokens truncated after 2</FormControl.Label>
        <TextInputWithTokens visibleTokenCount={2} block tokens={tokens} onTokenRemove={onTokenRemove} />
      </FormControl>
    </Box>
  )
}

render(VisibleTokenCountExample)
`}</code></pre>
    <h3>{`Render tokens on a single line`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const PreventTokenWrappingExample = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2},
    {text: 'three', id: 3},
    {text: 'four', id: 4},
    {text: 'five', id: 5},
    {text: 'six', id: 6},
    {text: 'seven', id: 7}
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <Box maxWidth="500px">
      <FormControl>
        <FormControl.Label>Tokens on one line</FormControl.Label>
        <TextInputWithTokens
          preventTokenWrapping
          block
          tokens={tokens}
          onTokenRemove={onTokenRemove}
          id="inputWithTokens-basic"
        />
      </FormControl>
    </Box>
  )
}

render(PreventTokenWrappingExample)
`}</code></pre>
    <h3>{`Set a maximum height for the input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const MaxHeightExample = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2},
    {text: 'three', id: 3},
    {text: 'four', id: 4},
    {text: 'five', id: 5},
    {text: 'six', id: 6},
    {text: 'seven', id: 7}
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <Box maxWidth="500px">
      <FormControl>
        <FormControl.Label>Tokens restricted to a max height</FormControl.Label>
        <TextInputWithTokens
          maxHeight="50px"
          block
          tokens={tokens}
          onTokenRemove={onTokenRemove}
          id="inputWithTokens-basic"
        />
      </FormControl>
    </Box>
  )
}

render(MaxHeightExample)
`}</code></pre>
    <h3>{`With an error validation status`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const ErrorExample = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2}
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <>
      <Box as="label" display="block" htmlFor="inputWithTokens-basic">
        Basic example tokens
      </Box>
      <TextInputWithTokens
        tokens={tokens}
        onTokenRemove={onTokenRemove}
        id="inputWithTokens-basic"
        validationStatus="error"
      />
    </>
  )
}

render(ErrorExample)
`}</code></pre>
    <h3>{`With leading and trailing visuals`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const LeadingVisualExample = () => {
  const [dates, setDates] = React.useState([
    {text: '01 Jan', id: 0},
    {text: '01 Feb', id: 1},
    {text: '01 Mar', id: 2}
  ])
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2}
  ])
  const onDateRemove = tokenId => {
    setDates(dates.filter(token => token.id !== tokenId))
  }
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <>
      <FormControl>
        <FormControl.Label>Dates</FormControl.Label>
        <TextInputWithTokens leadingVisual={CalendarIcon} tokens={dates} onTokenRemove={onDateRemove} />
      </FormControl>
      <FormControl>
        <FormControl.Label>Tokens</FormControl.Label>
        <TextInputWithTokens trailingVisual={CheckIcon} tokens={tokens} onTokenRemove={onTokenRemove} />
      </FormControl>
    </>
  )
}

render(LeadingVisualExample)
`}</code></pre>
    <h2>{`With visuals and loading indicators`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const WithIconAndLoadingIndicator = () => {
  const [dates, setDates] = React.useState([
    {text: '01 Jan', id: 0},
    {text: '01 Feb', id: 1},
    {text: '01 Mar', id: 2}
  ])
  const onDateRemove = tokenId => {
    setDates(dates.filter(token => token.id !== tokenId))
  }

  const [loading, setLoading] = React.useState(true)
  const toggleLoadingState = () => {
    setLoading(!loading)
  }

  return (
    <>
      <Box mb={5} display="flex" justifyContent="flex-end">
        <button type="button" onClick={toggleLoadingState}>
          Toggle loading state {loading ? 'off' : 'on'}
        </button>
      </Box>

      <h3>No visual</h3>
      <Box mb={2}>
        <TextInputWithTokens tokens={dates} onTokenRemove={onDateRemove} value="auto" loading={loading} />
      </Box>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          value="leading"
          loading={loading}
          loaderPosition="leading"
        />
      </Box>
      <Box mb={5}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          value="trailing"
          loading={loading}
          loaderPosition="trailing"
        />
      </Box>

      <h3>Leading visual</h3>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          leadingVisual={CalendarIcon}
          loading={loading}
          value="auto"
        />
      </Box>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          leadingVisual={CalendarIcon}
          loading={loading}
          loaderPosition="leading"
          value="leading"
        />
      </Box>
      <Box mb={5}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          leadingVisual={CalendarIcon}
          loading={loading}
          loaderPosition="trailing"
          value="trailing"
        />
      </Box>

      <h3>Trailing visual</h3>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          trailingVisual={CalendarIcon}
          loading={loading}
          value="auto"
        />
      </Box>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          trailingVisual={CalendarIcon}
          loading={loading}
          loaderPosition="leading"
          value="leading"
        />
      </Box>
      <Box mb={5}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          trailingVisual={CalendarIcon}
          loading={loading}
          loaderPosition="trailing"
          value="trailing"
        />
      </Box>

      <h3>Both visuals</h3>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          size="small"
          leadingVisual={CalendarIcon}
          trailingVisual={CalendarIcon}
          loading={loading}
          value="auto"
        />
      </Box>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          leadingVisual={CalendarIcon}
          trailingVisual={CalendarIcon}
          loading={loading}
          loaderPosition="leading"
          value="leading"
        />
      </Box>
      <Box mb={2}>
        <TextInputWithTokens
          tokens={dates}
          onTokenRemove={onDateRemove}
          size="large"
          leadingVisual={CalendarIcon}
          trailingVisual={CalendarIcon}
          loading={loading}
          loaderPosition="trailing"
          value="trailing"
        />
      </Box>
    </>
  )
}

render(<WithIconAndLoadingIndicator />)
`}</code></pre>
    <h2>{`Props`}</h2>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow required name="tokens" type="TokenProps[]" description="The array of tokens to render" mdxType="PropsTableRow" />
  <PropsTableRow required name="onTokenRemove" type="(tokenId: string|number) => void" description="The function that gets called when a token is removed" mdxType="PropsTableRow" />
  <PropsTableRow name="tokenComponent" type="React.ComponentType<any>" defaultValue="Token" description="The component used to render each token" mdxType="PropsTableRow" />
  <PropsTableRow name="maxHeight" type="React.CSSProperties['maxHeight']" description="The maximum height of the component. If the content in the input exceeds this height, it will scroll vertically" mdxType="PropsTableRow" />
  <PropsTableRow name="preventTokenWrapping" type="boolean" defaultValue="false" description="Whether tokens should render inline horizontally. By default, tokens wrap to new lines" mdxType="PropsTableRow" />
  <PropsTableRow name="size" type="'small' | 'medium' | 'large' | 'xlarge'" defaultValue="xlarge" description="The size of the tokens and text input" mdxType="PropsTableRow" />
  <PropsTableRow name="hideTokenRemoveButtons" type="boolean" defaultValue="false" description="Whether the remove buttons should be rendered in the tokens" mdxType="PropsTableRow" />
  <PropsTableRow name="validationStatus" type="'error' | 'success' | 'warning'" description="Style the input to match the status" mdxType="PropsTableRow" />
  <PropsTableRow name="visibleTokenCount" type="number" description="The number of tokens to display before truncating" mdxType="PropsTableRow" />
  <PropsTablePassthroughPropsRow elementName="TextInput" isPolymorphic passthroughPropsLink={<Link href="/react/TextInput" mdxType="Link">TextInput docs</Link>} mdxType="PropsTablePassthroughPropsRow" />
    </PropsTable>
    <h3>{`Adding and removing tokens`}</h3>
    <p>{`The array passed to the `}<inlineCode parentName="p">{`tokens`}</inlineCode>{` prop needs to be manually updated to add and remove tokens.`}</p>
    <p>{`The function passed to the `}<inlineCode parentName="p">{`onRemoveToken`}</inlineCode>{` prop is called when:`}</p>
    <ul>
      <li parentName="ul">{`Clicking the remove button in the token`}</li>
      <li parentName="ul">{`Pressing the `}<inlineCode parentName="li">{`Backspace`}</inlineCode>{` key when the input is empty`}</li>
      <li parentName="ul">{`Selecting a token using the arrow keys or by clicking on a token and then pressing the `}<inlineCode parentName="li">{`Backspace`}</inlineCode>{` key`}</li>
    </ul>
    <p>{`There is no function that gets called to "add" a token, so the user needs to be provided with a UI to select tokens.`}</p>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: true,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      